module.exports = __webpack_public_path__ + "img/d20.6dfbc8e1.svg";